module.exports = __webpack_public_path__ + "static/img/26.2f1c9628.jpg";